module.exports = __webpack_public_path__ + "2b1535389b8685f7101fd9352c0370fb.pdf";